export default "__VITE_ASSET__1f429f50__"